<template>
  <div class="container">
    <input id="files" style="display: none" type="file" ref="clearFile" @change="importFile()" />
    <div class="dropbox p-3" id="dragBox" @click="changeFn()">
      <img src="~@/assets/map_icons/上传.png" style="top: 14px;left: 153px;margin-bottom:9px;">
      <h1 class=" font-weight-light" style="font-size:14px;font-family:'微软雅黑';color: #2F66CC;">
        {{$vuetify.lang.t('$vuetify.search.rangeSelector.upload1')}}
      </h1>
      <h1 v-if="!(infoText!=='' && $store.state.search.selectedRangeStore['upload']!=='')" class=" font-weight-light" style="font-size:10px;font-family:'微软雅黑';color: #CCCCCC;">
        {{$vuetify.lang.t('$vuetify.search.rangeSelector.upload2')}}<br />{{$vuetify.lang.t('$vuetify.search.rangeSelector.upload3')}}
      </h1>
      <h1 v-if="infoText!=='' && $store.state.search.selectedRangeStore['upload']!==''" class="font-weight-light mt-2" style="font-size:10px;font-family:'微软雅黑';color: #CCCCCC;;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
        <v-icon color="success" size="18">check</v-icon>{{$vuetify.lang.t('$vuetify.search.rangeSelector.selected')}}{{infoText}}
      </h1>
    </div>
    <v-overlay :value="overlay">
      <span>正在处理，请稍后</span>
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :color=snackbarColor :timeout="timeout" bottom>
        {{snackbarInfo}}
        <v-btn dark text @click="snackbar = false" class="text-capitalize">
            {{$vuetify.lang.t('$vuetify.demand.close')}}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import L from 'leaflet'
  import * as omnivore from 'leaflet-omnivore/index'
  import * as JSZip from 'jszip'
  import proj4 from 'proj4'
  import reproject from 'reproject'
  import 'shapefile'
  import area from 'turf-area'
  import * as turf from "turf";
  import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
  

  var shapefile = require("shapefile")

  var geoJSON = ''
  var filename="";


  export default {
    inject:['Search'],
    props: {
      justShow: {
        type: Boolean,
        default:false
      }
    },
    name: 'SearchUploadFiles',
    data(){
      return{
        parentContainer: '',
        info: false,
        infoText:'',
        valueDeterminate: 0,
        showPrise: false,
        showAll: true,
        file: document.getElementById("file"),
        message: "",
        loader: null,
        suss: 0,
        open: ['public'],
        files: {
          html: 'mdi-language-html5',
          js: 'mdi-nodejs',
          json: 'mdi-json',
          md: 'mdi-markdown',
          pdf: '~@/assets/upload.png',
          png: 'mdi-file-image',
          txt: 'mdi-file-document-outline',
          xls: 'mdi-file-excel'
        },
        tree: [],
        items: [],

        // NOTE 新建的
        //提示相关参数
        snackbar:false,
        snackbarColor:"",
        snackbarInfo:"",
        timeout: 3000,


        overlay: false,
      }
    },
    mounted() {
      // this.parentContainer = this.findRealParent(this.$parent);
      this.parentContainer = this.Search;
      var dropbox = document.querySelector('.dropbox');
      dropbox.addEventListener('dragenter', this.onDrag, false);
      dropbox.addEventListener('dragover', this.onDrag, false);
      dropbox.addEventListener('drop', this.onDrop, false);
    },
    methods: {
      changeFn() {
        document.getElementById("files").click();
      },
      importFile() {
        var selectedFile = document.getElementById("files").files[0];//获取读取的File对象
        filename = this.omitName(selectedFile.name);
        this.infoText = selectedFile.name
        this.info = true
        this.fileReader(selectedFile);
      },
      fileReader(file) {
        if (["kml","kmz","zip"].includes(file.name.slice(-3))) {
          let data = new FormData();
          data.append('file', file);
          if (this.justShow) {
            data.append('justShow', this.justShow);
          }
          this.infoText = '正在读取目标文件……'
          this.info = false
          // this.overlay=true
          this.axios({
              method: 'post',
              timeout: 1000000,
              url: '/koa_back/makeGeoValid',
              headers: {
                  'Content-Type': 'multipart/form-data'
              },
              data:data
          }).then((res) => {
            // this.overlay=false
            this.infoText = file.name
            this.info = true
            let geoJson = JSON.parse(res.data.validjson);
            console.log('geoJson',geoJson)

            // TODO 创建矢量时是不做限制的，只有在项目中选择时做限制
            // if (!["Polygon","MultiPolygon"].includes(geoJson.type)) {
            //     this.snackbar=true
            //     this.snackbarColor = 'error'
            //     this.snackbarInfo = '暂不支持使用点或线矢量裁剪，请重新上传！'
            //     return
            // }
            // let bbox=turf.bbox(geoJson)
            // let width=turf.distance(turf.point([bbox[0],bbox[3]]),turf.point([bbox[2],bbox[3]]))//得用同纬度的计算
            // let width1=turf.distance(turf.point([bbox[0],bbox[3]]),turf.point([bbox[0],bbox[1]]))//得用同经度的计算
            // // TODO 宽度暂时这样判断，待改
            // if (width<5||width1<5) {
            //     this.snackbar=true
            //     this.snackbarColor = 'error'
            //     this.snackbarInfo = '裁剪矢量最小宽度不得低于5km，请重新上传！'
            //     return
            // }

            // // TODO 面积扩充到100km²

            this.$store.state.search.selectedRangeStore['upload'] = geoJson

            bus.$emit('showUploadVector',geoJson)

            // let formdata = new FormData()
            // let geom=JSON.stringify(this.$store.state.search.selectedRangeStore[this.$store.state.search.targetType])
            // formdata.append("geom",geom)
            // this.axios.post("/koa_back/geomAreaHandle",formdata).then(res => {
            //   this.Search.bufferGeo.geojson=JSON.parse(res.data.data.geojson)
            //   this.Search.bufferGeo.area = res.data.data.area
            //   this.snackbar=true
            //   this.snackbarColor = '#ff9900'
            //   this.snackbarInfo = `已自动将您上传的矢量面积扩充到${res.data.data.area.toFixed(2)}平方公里！`
            // })
          })
        }else{
          console.error('请检查文件类型，目前只支持.kml .kmz .zip(需包含.shp和.prj)')
        }

      },
      // fileReader(file) {
      //   geoJSON = undefined;
      //   filename = "";
      //   this.$refs.clearFile.value = ''
      //   if(file.name.slice(-3) === "kml") {
      //     let reader = new FileReader();
      //     reader.onload = () => {
      //       if(reader.readyState != 2 || reader.error){
      //         return;
      //       }
      //       else{
      //         var customLayer=L.geoJSON(null,{fill:false});
      //         var kmlLayer = omnivore.kml(reader.result,null,customLayer)
      //                 .on('ready',(e)=>{
      //                   var tempGeoJSON = e.target.toGeoJSON()
      //                   this.$store.state.search.selectedRangeStore['upload'] = tempGeoJSON
      //                   this.$parent.$parent.$parent.$parent.$parent.showAreaCount()
      //                   this.parentContainer.searchAll()
      //                 })
      //       }
      //     }
      //     reader.readAsDataURL(file);//将file文件编码成DATAUrl
      //   }

      //   else if(file.name.slice(-3) === "kmz"){
      //     let reader =new FileReader();
      //     reader.onload = () => {
      //       //upload();
      //       if (reader.readyState != 2 || reader.error) {

      //         return;
      //       }

      //       else {
      //         JSZip.loadAsync(reader.result,{fill:false})
      //                 .then((zip) => {
      //                   return zip.file(/.*\.kml/)[0].async("string");
      //                 })
      //                 .then((text) => {
      //                   var tempGeoJSON = omnivore.kml.parse(text).toGeoJSON()
      //                   this.$store.state.search.selectedRangeStore['upload'] = tempGeoJSON
      //                   this.$parent.$parent.$parent.$parent.$parent.showAreaCount()
      //                   this.parentContainer.searchAll()
      //                 })
      //       }
      //     }
      //     reader.readAsArrayBuffer(file);
      //   }

      //   else if(file.name.slice(-3) === "zip"){
      //     let reader = new FileReader();
      //     var shpName,prjName

      //     var a = 0,b = 0,c = 0, d = 0;
      //     reader.onload = ()=>{
      //       if (reader.readyState != 2 || reader.error) {
      //         return;
      //       }
      //       else {
      //         JSZip.loadAsync(reader.result)
      //                 .then((zip)=> {
      //                   var files = zip.file(/.+/);
      //                   files.forEach((x)=>{
      //                     if (x.name.slice(-3).toLowerCase() === 'shp') {
      //                       a = 1
      //                       shpName = x.name
      //                     }
      //                     if (x.name.slice(-3).toLowerCase() === 'prj') {
      //                       b = 1;
      //                       prjName = x.name
      //                     }
      //                   });
      //                   return a*b;
      //                 })
      //                 .then((bool)=>{
      //                   if(bool){
      //                     JSZip.loadAsync(reader.result)
      //                             .then((zip)=> {
      //                               debugger
      //                               Promise.all([zip.file(shpName).async("arraybuffer"), zip.file(prjName).async("string")])
      //                                       .then((result) => {
      //                                         shapefile.read(result[0])
      //                                                 .then((source) => {
      //                                                   // debugger//TODO调试"长春市测绘院2022年采购范围"投影问题
      //                                                   var tempGeoJSON = reproject.reproject(source, result[1], proj4.WGS84)
      //                                                   this.$store.state.search.selectedRangeStore['upload'] = tempGeoJSON
      //                                                   console.log(tempGeoJSON)
      //                                                   this.$parent.$parent.$parent.$parent.$parent.showAreaCount()
      //                                                   this.parentContainer.searchAll()
      //                                                 })
      //                                       })
      //                             })
      //                   }else{
      //                     console.log('该zip文件不符合文件格式要求，请点击重置清空文件缓存')
      //                   }
      //                 });
      //       }
      //     }
      //     reader.readAsArrayBuffer(file);
      //   }

      //   else{console.log(file.name.slice(-3))}

      // },
      onDrag: function (e) {
        e.stopPropagation();
        e.preventDefault();
      },
      onDrop: function (e) {
        e.stopPropagation();
        e.preventDefault();
        e.stopPropagation();
        e.preventDefault();
        var selectedFile = e.dataTransfer.files[0]
        filename =selectedFile.name;
        this.fileReader(selectedFile);

      },
      omitName (str) {
        var realLength = 0, len = str.length, charCode = -1;
        for (var i = 0; i < len; i++) {
          charCode = str.charCodeAt(i);
          if (charCode >= 0 && charCode <= 128) realLength += 1;
          else realLength += 2;
        }
        if (realLength > 12) {
          return str.substring(0, 10) + "...zip"
        }
        else
          return str
      },
    }
  }
</script>

<style lang="scss" scoped>
  /*@import "../global.scss";*/
  .container{
    width: 100%;
    height: 100%;
    background: #2A2A2A;
    border-radius: 4px;
    border: 1px solid #979797;
    opacity: 0.9;
  }
  .dropbox{
    height:100%;
    width:100%;
    text-align:center;
  }
</style>
